import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { LockOutlined } from '@ant-design/icons';

const Forbidden = () => {
  const navigate = useNavigate();

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      background: '#f0f2f5'
    }}>
      <Result
        status="403"
        icon={<LockOutlined style={{ color: '#ff4d4f' }} />}
        title="403 - Доступ запрещен"
        subTitle="У вас нет прав для доступа к этой странице. Обратитесь к администратору системы."
        extra={[
          <Button 
            type="primary" 
            key="dashboard"
            onClick={() => navigate('/dashboard')}
          >
            Вернуться на главную
          </Button>,
          <Button 
            key="back"
            onClick={() => navigate(-1)}
          >
            Назад
          </Button>
        ]}
      />
    </div>
  );
};

export default Forbidden;
